<template>
  <article class="empresas_conta_relatorio">
    <span class="duplicata_parcelada">
      <v-tooltip top :close-delay="500" allow-overflow>
        <v-chip
          slot="activator"
          small
          color="grey darken-1"
          text-color="white"
          @click.native="openTabela(item)"
        >{{item.rela_totalEmp}}</v-chip>
        <span>Visualizar tabela de empresas</span>
      </v-tooltip>
    </span>
    <v-dialog persistent @keydown.esc="openDialog = false" v-model="openDialog">
      <v-card>
        <v-card-title>
          <span>
            <strong>Empresas de: {{item.rela_nome}}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <!-- <div class="relatorioBtnDivider">
          <div>
            <v-btn @click="downloadExcelReport" style="background: teal; color: white; margin-left: 2.8rem;">Exportar Para Excel</v-btn>
          </div>
          <div>
            <v-btn @click="getMouthData('Mês Atual', 1)" style="background: teal; color: white;">Mês Atual</v-btn>
            <v-btn @click="getMouthData('Mês Anterior', 2)" style="background: teal; color: white; margin-right: 2.8rem;">Mês Anterior</v-btn>
          </div>
        </div> -->

        <v-card-text>
          <!-- <span style="margin-left: 1.8rem;" v-if="currentFilter">Notas do {{ currentFilter }}</span>
          <span style="margin-left: 1.8rem;" v-else>Período não selecionado</span> -->
          <v-container grid-list-md style="max-width: 100%">
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <table border="1" class="table_vencimento" :id="`tabela-relatorio-contas-${item._id}`">
                  <thead>
                    <tr>
                      <th colspan="1">CNPJ/CPF</th>
                      <th colspan="1" style="min-width: 388px;">Razão Social</th>
                      <th colspan="1">Data de Cadastro da Empresa</th>
                      <th colspan="1">Colaboradores</th>
                      <!-- <th colspan="1">NF-e Recebida</th>
                      <th colspan="1">NF-e Emitida</th>
                      <th colspan="1">NFS-e Recebida</th>
                      <th colspan="1">NFS-e Emitida</th>
                      <th colspan="1">CT-e Tomada</th>
                      <th colspan="1">CT-e não Tomada</th> -->
                      <th colspan="1">Vencimento certificado</th>
                      <th colspan="1">Bloqueada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in item.arrayEmpresas" :key="i">
                      <!-- <td class="text-xs-center">{{ item_consulta(item) }}</td> -->
                      <td class="text-xs-center">{{maskCnpj(item.empresa.cnpj)}}</td>
                      <td class="text-xs-center">{{item.empresa.razao}}</td>
                      <td
                        class="text-xs-center"
                      >{{item.empresa.dtReg != undefined && new Date(item.empresa.dtReg) instanceof Date && !isNaN((new Date(item.empresa.dtReg))) ? new Date(item.empresa.dtReg).toLocaleDateString('pt-BR') : item.empresa.dtReg }}</td>
                      <td class="text-xs-center">{{item.colaboradores.length}}</td>
                      <!-- <td class="text-xs-center">{{item.empresa.nfe_recebida}}</td>
                      <td class="text-xs-center">{{item.empresa.nfe_emitida}}</td>
                      <td class="text-xs-center">{{item.empresa.nfse_recebida}}</td>
                      <td class="text-xs-center">{{item.empresa.nfse_emitida}}</td>
                      <td class="text-xs-center">{{item.empresa.cte_tomada}}</td>
                      <td class="text-xs-center">{{item.empresa.cte_nao_tomada}}</td> -->
                      <td class="text-xs-center"
                      >{{item.empresa.certificado != undefined && new Date(item.empresa.certificado.validade) instanceof Date && !isNaN((new Date(item.empresa.certificado.validade))) ? new Date(item.empresa.certificado.validade).toLocaleDateString('pt-BR') : 'Certificado não vinculado' }}</td>
                      <td class="text-xs-center">{{item.empresa.bloqueada ? 'Sim' : 'Não'}}</td>
                    </tr>
                    <!-- <tr>
                      <td class="text-xs-center">TOTAL:</td>
                      <td style="background: #ccc"></td>
                      <td style="background: #ccc"></td>
                      <td style="background: #ccc"></td>
                      <td style="background: #ccc"></td>
                      <td style="background: #ccc"></td>
                       <td class="text-xs-center">{{total_nfe_recebida}}</td>
                      <td class="text-xs-center">{{total_nfe_emitida}}</td>
                      <td class="text-xs-center">{{total_nfse_recebida}}</td>
                      <td class="text-xs-center">{{total_nfse_emitida}}</td>
                      <td class="text-xs-center">{{total_cte_tomada}}</td>
                      <td class="text-xs-center">{{total_cte_nao_tomada}}</td> 
                      <td style="background: #ccc"></td>
                    </tr> -->
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="openDialog=false">Fechar</v-btn>
          <!-- <v-btn color="success"  @click.stop="newColumn()">Criar</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
import ContaService from '../../../../domain/conta/ContaService'

export default {
  props: ["item", "empresa", "component"],
  beforeMount() {},
  data: () => ({
    openDialog: false,
    currentFilter: '',
    total_cte_nao_tomada: '',
    total_cte_tomada: '',
    total_nfe_emitida: '',
    total_nfe_recebida: '',
    total_nfse_emitida: '',
    total_nfse_recebida: '',
  }),
  methods: {
    getMouthData: async function(label, month) {
      this.currentFilter = label;
      this.service = new ContaService(this.$http);
      this.activeGlobalLoader();
      const resp = await this.service.relatorioContasNotas('5c798e5640bd8100176b1650', this.item._id, month);

      if(resp && resp.conta) {
        const auxList = [...this.item.arrayEmpresas];
        if(auxList && auxList.length > 0) {
          auxList.map((comp, key) => {
            if(comp.empresa._id === resp.conta.empresas[key].empresa._id) {
              comp.empresa.nfe_recebida = resp.conta.empresas[key].empresa.nfe_recebida
              comp.empresa.nfe_emitida = resp.conta.empresas[key].empresa.nfe_emitida
              comp.empresa.nfse_recebida = resp.conta.empresas[key].empresa.nfse_recebida
              comp.empresa.nfse_emitida = resp.conta.empresas[key].empresa.nfse_emitida
              comp.empresa.cte_tomada = resp.conta.empresas[key].empresa.cte_tomada
              comp.empresa.cte_nao_tomada = resp.conta.empresas[key].empresa.cte_nao_tomada
            }
          })

          this.item.arrayEmpresas = auxList;
        }
        this.total_nfe_recebida = resp.conta.total_nfe_recebida
        this.total_nfe_emitida = resp.conta.total_nfe_emitida
        this.total_cte_tomada = resp.conta.total_cte_tomada
        this.total_cte_nao_tomada = resp.conta.total_cte_nao_tomada
        this.total_nfse_recebida = resp.conta.total_nfse_recebida
        this.total_nfse_emitida = resp.conta.total_nfse_emitida
      }
      this.desactiveGlobalLoader();
    },
    maskCnpj: function(cnpj) {
      // console.log('CNPJ', cnpj)
      return cnpj != undefined
        ? cnpj.length > 11
          ? cnpj.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5"
            )
          : cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")
        : "";
    },
    item_consulta: function (item) {
      console.log('ITEM', item)
      return ''
    },
    openTabela: function() {
      this.openDialog = true;
    },
    downloadExcelReport: function() {
      const id = `tabela-relatorio-contas-${this.item._id}`;
      
      var tab_text="<table border='2px'><tr bgcolor='#87AFC6'>"; 
      var j=0;
      var tab = document.getElementById(id);
      var sa;

      for(j = 0 ; j < tab.rows.length ; j++) {     
        tab_text=tab_text+tab.rows[j].innerHTML+"</tr>";
      }

      tab_text=tab_text+"</table>";
      tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");
      tab_text= tab_text.replace(/<img[^>]*>/gi,"");
      tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE "); 

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        txtArea1.document.open("txt/html","replace");
        txtArea1.document.write(tab_text);
        txtArea1.document.close();
        txtArea1.focus(); 
        sa=txtArea1.document.execCommand("SaveAs",true,"Say Thanks to Sumit.xls");
    }  
      else
        sa = window.open('data:application/vnd.ms-excel,' + escape(tab_text));  

      return (sa);
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
  }
};
</script>
<style>
.duplicata_sem_dt_venc {
  color: red;
}
.table_vencimento {
  border-collapse: collapse;
  width: 100%;
}
.table_vencimento td,
.table_vencimento th {
  border: 1px solid black;
}
.table_vencimento td {
  padding: 0px 5px;
}
.table_vencimento td.valorReais {
  position: relative;
}
.table_vencimento td.valorReais:before {
  left: 4px;
  position: absolute;
}
.duplicata_parcelada span.v-chip__content {
  cursor: pointer;
  font-size: 1.7em !important;
}
.empresas_conta_relatorio .table_vencimento th {
  padding: 10px;
}
.relatorioBtnDivider {
  display: flex;
  justify-content: space-between;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_listEmprConta/Coluna_listEmprConta.vue